// extracted by mini-css-extract-plugin
module.exports = {"layout":"layouts-module--layout--kb8am","layoutMain":"layouts-module--layoutMain--2PNB_"};